import * as React from 'react';
export const hanaSvg = React.forwardRef(function hanaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#085E63',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.09 7.568c0 1.116.863 2.019 1.929 2.019 1.065 0 1.928-.903 1.928-2.019 0-.274-.128-.549-.234-.746-.118-.218-.215-.398-.198-.723.024-.59-.705-.599-1.089-.599-1.202 0-2.327.788-2.327 2.068h-.008Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.625 8.84c.274-.008.525.189.525.484 0 .248-.212.442-.392.583-.885.714-1.896 1.272-2.923 1.715-3.16 1.37-6.617 1.793-10 2.249-1.967.27-3.934.467-5.909.599-1.35.091-3.086-1.193-3.667-2.356-.29-.574-.322-1.452.188-1.912.384-.352.98-.336 1.457-.295 1.458.127 2.896.524 4.342.739 5.164.78 10.697.41 15.595-1.543.251-.107.51-.255.784-.263ZM19.64 22.955c-.495 1.551-1.208 3.07-2.32 4.243-.189.197-.416.386-.698.263a.371.371 0 0 1-.172-.14c-.082-.127-.034-.292.005-.43a.724.724 0 0 0 .018-.062c.055-.197.11-.394.157-.591.486-1.912.94-3.972.846-5.966-.023-.451-.078-.92-.266-1.33-.476-1.037-1.865-1.147-2.296.009-.212.59-.134 1.19-.04 1.797.268 1.624-1.6 1.874-2.366.607-1.108-1.878-.49-4.78 1.355-5.966a3.952 3.952 0 0 1 4.217-.025c2.675 1.634 2.364 4.99 1.56 7.591Z',
      fill: '#fff',
    }),
  );
});
hanaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hana = {
  category: 'brand',
  colorable: false,
  name: 'hana',
  svg: hanaSvg,
};
